/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useState, useMemo, useEffect } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { OverlayTrigger, Tooltip, Tab } from "react-bootstrap";
import SVG from "react-inlinesvg";
import objectPath from "object-path";
import { useHtmlClassService } from "../../../_core/MetronicLayout";
import { toAbsoluteUrl } from "../../../../_helpers";
import { DropdownTopbarItemToggler } from "../../../../_partials/dropdowns";
import AppConfig from "../../../../../app/config/AppConfig";
import PerfectScrollbar from "react-perfect-scrollbar";
import Axios from "axios";
import { NavLink } from "react-router-dom";

import Moment from "moment";

const perfectScrollbarOptions = {
  wheelSpeed: 2,
  wheelPropagation: false,
};
export function UserNotificationsDropdownReviewer() {
  const bgImage = toAbsoluteUrl("/media/misc/bg-2.jpg");
  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      offcanvas:
        objectPath.get(uiService.config, "extras.notifications.layout") ===
        "offcanvas",
    };
  }, [uiService]);

  const [loading, setLoading] = useState(false);
  const [data, Setdata] = useState([]);
  const [limit, SetLimit] = useState(5);

  useEffect(() => {
    let isMounted = true;

    const fetchNotifications = async () => {

      let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
      let userdata = JSON.parse(localStorage.getItem("userdata"));
      let id_sp = sessiondata.i_idunit;
      // let id_sp = "86942CDF-44F1-446E-8E9E-CB37BBBB16E6";
      let session = "";
  
      if (userdata) {
        session =
          "?id_pengguna=" +
          userdata.id_pengguna +
          "&id_unit=" +
          id_sp +
          "&id_role=" +
          sessiondata.i_idrole;
      }
      if (!id_sp) return;

      setLoading(true);
      try {
        const formData = new FormData();
        formData.append("data[id_unit]", sessiondata.i_idunit);
        formData.append("data[id_bp]", sessiondata.i_idbp);
        if (sessiondata.id_sp_penugasan !== null && sessiondata.i_idrole === 2013) {
          let data_pt = "'" + sessiondata.id_sp_penugasan.join("','") + "'";
          formData.append("data[id_sp]", data_pt);
        }
        const response = await Axios.post(
          AppConfig.GetNotifSelainPT +
            session +
            `&limit=${limit}&page=1`,
          formData
        );
        if (isMounted) {
          const notif = response.data.result || []; 
          Setdata(notif);
          // console.log("sukses");

        }
      } catch (error) {
        if (isMounted) {
          console.error("Gagal mengambil notifikasi:", error);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchNotifications();

    return () => {
      isMounted = false;
    };
  }, []);
  return (
    <>
      {layoutProps.offcanvas && (
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="quick-actions-tooltip">Notifications</Tooltip>}
        >
          <div className="topbar-item">
            <div
              className="btn btn-icon btn-clean btn-lg mr-1 pulse pulse-primary"
              id="kt_quick_actions_toggle"
            >
              <span className="svg-icon svg-icon-xl svg-icon-primary">
              <SVG src={toAbsoluteUrl("/media/svg/icons/General/Notifications1.svg")} />
              </span>
              <span className="pulse-ring"></span>
            </div>
          </div>
        </OverlayTrigger>
      )}
      {!layoutProps.offcanvas && (
        <Dropdown drop="down" align="end">
          <Dropdown.Toggle
            as={DropdownTopbarItemToggler}
            id="kt_quick_actions_panel_toggle"
          >
            <OverlayTrigger
                placement="bottom"
                overlay={
                  <Tooltip id="user-notification-tooltip">
                    Notifications
                  </Tooltip>
                }
              >
                <div
                  className="btn btn-icon btn-clean btn-lg mr-1 pulse pulse-primary"
                  id="kt_quick_notifications_toggle"
                >
                  <span className="svg-icon svg-icon-xl svg-icon-primary">
                  <SVG
                      src={toAbsoluteUrl("/media/svg/icons/General/Notifications1.svg")}
                    />
                  </span>
                  <span className="pulse-ring"></span>
                  <span className="pulse-ring" />
                </div>
              </OverlayTrigger>
          </Dropdown.Toggle>

          <Dropdown.Menu className="p-0 m-0 dropdown-menu-anim-up dropdown-menu-xl"
            style={{width: '430px'}}>
            <form>
              {/* begin: Head */}
              <div
                className="d-flex flex-column align-items-center justify-content-center pt-10 pb-10 bgi-size-cover bgi-no-repeat rounded-top"
                style={{ backgroundImage: `url(${bgImage})` }}
              >
                <h3 className="text-white font-weight-bold font-size-5">
                  Notification
                </h3>
              </div>
              {/* end: Head */}
              <Tab.Content className="tab-content">
                <PerfectScrollbar
                  options={perfectScrollbarOptions}
                  className="scroll pr-7 mr-n7"
                  style={{ maxHeight: "300px", position: "relative" }}
                >
                  {/* saya ingin melooping data disni pada navlink dengan state data */}
                  {Array.isArray(data) && data.length > 0 ? (
                    data.map((notif, index) => (
                      <NavLink
                                className="d-block py-2 px-3 bg-hover-light border-right border-bottom bg-light"
                                to={`/detail-pt/${notif.id_pt}`}
                                          >
                                            <div className="navi-link d-flex">
                                              <div className="navi-icon mr-2">
                                                <i className="fa fa-bell text-primary"></i> 
                                              </div>
                                              <div className="navi-text">
                                              <div className="font-weight-bold text-primary">{notif.jenis_notif}</div>
                                                <div className="text-muted d-flex">
                                                  Perguruan Tinggi {notif.nm_lemb} telah menyimpan pengaturan jenis {notif.jenis_notif} - 
                                                  {Moment(notif.tgl_create || new Date()).fromNow()}
                                                </div>
                                                <div className="text-muted d-flex align-items-center">
                                                  
                                                </div>
                                              </div>
                                            </div>
                                  </NavLink>
                    ))
                  ) : (

                    <div className="text-center py-4 text-muted">
                      Tidak ada notifikasi
                    </div>
                  )}
                    <NavLink
                                className="d-block py-2 px-3 bg-hover-light border-right border-bottom bg-light"
                    to="/notification"
                    // to="/detail-pt/"
                              >
                                <div className="navi-link d-flex">
                                  <div className="navi-icon mr-2">
                                    <i className="fa fa-bell text-primary"></i> 
                                  </div>
                                  <div className="navi-text">
                                  <div className="font-weight-bold text-primary">Penetapan</div>
                                    <div className="text-muted d-flex">
                                      Perguruan Tinggi Akademi Bakti Kemanusiaan Palang Merah Indonesia telah menyimpan pengaturan jenis Peningkatan - 
                                      {Moment("2025-05-20" || new Date()).fromNow()}
                                    </div>
                                    <div className="text-muted d-flex align-items-center">
                                      
                                    </div>
                                  </div>
                                </div>
                      </NavLink>
                      
                </PerfectScrollbar>
              </Tab.Content>
              <div className="row row-paddingless">
                <div className="col-12">
                  <NavLink
                    to="/notification"
                    className="d-block py-5 px-5 text-center bg-hover-light border-right border-bottom"
                  >
                    <span className="d-block text-primary-50 font-size-lg">
                      Lihat Selengkapnya
                    </span>
                  </NavLink>
                </div>
              </div>
            </form>
          </Dropdown.Menu>
        </Dropdown>
      )}
    </>
  );
}
